function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_7552",
  "data-name": "Grupo 7552",
  transform: "translate(-1744 218.173)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rect\\xE1ngulo_42",
  "data-name": "Rect\\xE1ngulo 42",
  transform: "translate(1744 -218.173)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 3,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 2,
  height: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rect\\xE1ngulo_45",
  "data-name": "Rect\\xE1ngulo 45",
  transform: "translate(1748 -218.173)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 9,
  height: 3,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 8,
  height: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rect\\xE1ngulo_43",
  "data-name": "Rect\\xE1ngulo 43",
  transform: "translate(1744 -214.173)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 3,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 2,
  height: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rect\\xE1ngulo_46",
  "data-name": "Rect\\xE1ngulo 46",
  transform: "translate(1748 -214.173)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 9,
  height: 3,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 8,
  height: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rect\\xE1ngulo_44",
  "data-name": "Rect\\xE1ngulo 44",
  transform: "translate(1744 -210.173)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 3,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 2,
  height: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rect\\xE1ngulo_47",
  "data-name": "Rect\\xE1ngulo 47",
  transform: "translate(1748 -210.173)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 9,
  height: 3,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 8,
  height: 2,
  fill: "none"
})));

function SvgListaof(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListaof);
export default __webpack_public_path__ + "static/media/listaof.b23d68eb.svg";
export { ForwardRef as ReactComponent };